import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faUserCircle,
  faCalendarCheck,
  faPassport,
  faPhoneAlt,
  faEnvelopeOpenText,
  faMapMarkerAlt,
  faUsers,
  faIdCard,
  faSuitcaseRolling
} from '@fortawesome/free-solid-svg-icons';
import TenantSidebar from "../../components/Sidebar/TenantSidebar";
import './TenantProfile.css';

const TenantProfile = () => {
  const [tenant, setTenant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user'));
    if (!user?.email) {
      window.location.href = '/login';
    } else {
      fetchTenant(user.email);
    }
  }, []);

  const fetchTenant = async (email) => {
    try {
      const res = await fetch(`https://ikaze-thouse-backend.vercel.app/api/v1/tenants/tenantDetailByEmail/${email}`);
      const result = await res.json();
      if (result.success) setTenant(result.data);
      else setError(result.message || 'Tenant not found');
    } catch (err) {
      setError('Connection failed');
    } finally {
      setLoading(false);
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    return new Date(dateString).toLocaleDateString('en-GB', {
      day: 'numeric', month: 'long', year: 'numeric'
    });
  };

  if (loading) return <div className="state-container">Loading Profile...</div>;
  if (error) return <div className="state-container" style={{color: 'red'}}>{error}</div>;

  return (
    <>
      <TenantSidebar />
      <div className="profile-wrapper">
        <div className="profile-container">
          
          {tenant && (
            <>
              {/* Main Identity Header */}
              <div className="profile-header">
                <div className="profile-avatar-wrapper">
                  <FontAwesomeIcon icon={faUserCircle} />
                </div>
                <h1>{tenant.guest_name}</h1>
                <div className="tenant-id">REF: {tenant.tenant_id}</div>
              </div>

              <div className="profile-content-grid">
                
                {/* Stay Details Card */}
                <div className="profile-card">
                  <h2 className="profile-card-title">
                    <FontAwesomeIcon icon={faSuitcaseRolling} /> Stay Details
                  </h2>
                  <div className="profile-info-row">
                    <span className="info-label">Check-in Date</span>
                    <span className="info-value">{formatDate(tenant.arrival_date)}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Check-out Date</span>
                    <span className="info-value">{formatDate(tenant.departure_date)}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Assigned Unit</span>
                    <span className="info-value">Unit {tenant.appartment_unite}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Occupancy</span>
                    <span className="info-value">{tenant.number_adults} Adults, {tenant.number_child} Children</span>
                  </div>
                </div>

                {/* Personal & Legal Card */}
                <div className="profile-card">
                  <h2 className="profile-card-title">
                    <FontAwesomeIcon icon={faIdCard} /> Personal Information
                  </h2>
                  <div className="profile-info-row">
                    <span className="info-label">Email Address</span>
                    <span className="info-value">{tenant.email_address}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Phone Number</span>
                    <span className="info-value">{tenant.mobile_number}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Nationality</span>
                    <span className="info-value">{tenant.nationalite}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Passport / ID</span>
                    <span className="info-value">{tenant.passport_id}</span>
                  </div>
                  <div className="profile-info-row">
                    <span className="info-label">Country of Residence</span>
                    <span className="info-value">{tenant.country_residence}</span>
                  </div>
                </div>

              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default TenantProfile;